<template>
  <el-dialog
    title="修改用户角色"
    :visible.sync="dialogVisible"
    width="30%"
    :close-on-click-modal="false"
    :destroy-on-close="true">
    <div>
      <div style="margin-bottom: 15px;">
        <span>用户名: {{ user.username }}</span>
      </div>
      <div>
        <el-form :model="form" label-width="80px">
          <el-form-item label="角色">
            <el-select v-model="form.roleId" placeholder="请选择角色">
              <el-option
                v-for="item in roleList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="saveRole" :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "changeUserRole",
  data() {
    return {
      dialogVisible: false,
      user: {},
      form: {
        roleId: ''
      },
      roleList: [],
      loading: false,
      callback: null
    };
  },
  methods: {
    openDialog(user, callback) {
      this.dialogVisible = true;
      this.user = user;
      this.callback = callback;
      this.loading = false;
      this.form.roleId = user.roleId || '';
      this.loadRoles();
    },
    close() {
      this.dialogVisible = false;
    },
    loadRoles() {
      // 加载所有角色
      this.$axios({
        method: 'get',
        url: '/api/role/all',
      }).then(res => {
        if (res.data.code === 0) {
          this.roleList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(error => {
        console.error(error);
        this.$message.error('获取角色列表失败');
      });
    },
    saveRole() {
      if (!this.form.roleId) {
        this.$message.warning('请选择角色');
        return;
      }
      
      this.loading = true;
      this.$axios({
        method: 'post',
        url: '/api/user/changeUserRole',
        params: {
          userId: this.user.id,
          roleId: this.form.roleId
        }
      }).then(res => {
        this.loading = false;
        if (res.data.code === 0) {
          if (this.callback) {
            this.callback();
          }
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(error => {
        this.loading = false;
        console.error(error);
        this.$message.error('修改用户角色失败');
      });
    }
  }
};
</script>

<style scoped>
.el-select {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/changeUserRole.vue